export default "__VITE_ASSET__BLJ8WQzX__"